package com.zaurh.portfolio.main

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.zaurh.portfolio.domain.repository.ContactRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class MainViewModel(
    private val repository: ContactRepository
) : ViewModel() {

    private val _buttonDisabled = MutableStateFlow(false)
    val buttonDisabled = _buttonDisabled.asStateFlow()

    private val _buttonText = MutableStateFlow("Send message")
    val buttonText = _buttonText.asStateFlow()

    private val _darkModeEnabled = MutableStateFlow(true)
    val darkModeEnabled = _darkModeEnabled.asStateFlow()

    fun sendMessage(
        name: String,
        email: String,
        subject: String,
        message: String
    ) {
        viewModelScope.launch {
            _buttonText.value = "Sending..."
            val result = repository.sendContactMessage(
                name = name,
                email = email,
                subject = subject,
                message = message
            )

            if (result){
                _buttonDisabled.value = true
                _buttonText.value = "Message sent!"
            } else {
                _buttonDisabled.value = true
                _buttonText.value = "Something went wrong!"
            }
        }
    }

    fun toggleDarkMode(){
        _darkModeEnabled.value = !darkModeEnabled.value
    }
}